import Box from "@mui/material/Box";
import {
  GridFilterPanel,
  type GridFilterPanelProps,
} from "@mui/x-data-grid-premium";

/** Column filter panel with a short notice above the filter form. */
export function RegulationsGridFilterPanel(props: GridFilterPanelProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <Box
        component="p"
        className="regulations-filter-panel-tip"
        sx={{
          m: 0,
          px: 2,
          pt: 1.5,
          pb: 0.5,
          fontSize: "12px",
          lineHeight: 1.4,
          color: "#a2a2a2",
        }}
      >
        Tips: This is a temporary filter.
      </Box>
      <GridFilterPanel {...props} />
    </Box>
  );
}
